import * as actions from '../actions/budgeting'
import * as paymentActions from '../actions/payment'
import {LATE_PAYMENT_AWARENESS, VERIFIED_INCOME} from '../../lib/util/activity'
import Immutable from 'seamless-immutable'

const initialState = Immutable({
	lastUpcomingActivityReceived: 0,

	healthIndex: 0,
	savingsWithdrawalEnabled: false,
	surplusWithdrawalEnabled: false,
	withdrawalLimit: NaN,

	pendingWithdrawals: [],
	transferDestinations: [],
	upcomingActivity: [],
	upcomingActivityCurrentTab: 0,
	bPayActivity: [],
	onHoldActivity: [],
	incomeActivity: [],
	twelveMonth: {}
})

export default function (state = initialState, action){
	switch(action.type){
		case actions.BUDGET_HEALTH:
			return state.set('healthIndex', action.healthIndex)

		case actions.BUDGET_WITHDRAWAL_CONFIGURATION:
			return state
				.set('savingsWithdrawalEnabled', action.config.savingsWithdrawalEnabled)
				.set('surplusWithdrawalEnabled', action.config.surplusWithdrawalEnabled)
				.set('withdrawalLimit', action.config.withdrawalLimit)

		case actions.BUDGET_UPDATE_PENDING_WITHDRAWALS:
			return state.set('pendingWithdrawals', action.withdrawals)

		case actions.BUDGET_CANCEL_PENDING_WITHDRAWAL:
			return state.update('pendingWithdrawals', (withdrawals) => withdrawals.filter((w) => w.id !== action.id))

		case actions.BUDGET_TRANSFER_DESTINATIONS:
			return state
				.set('transferDestinations', action.transferDestinations)

		case actions.BUDGET_UPDATE_UPCOMING_ACTIVITY:
			const loadSuccessState = state.set('lastUpcomingActivityReceived', action.upcomingActivity.length)
			if(action.pageOffset > 0){
				return loadSuccessState.set('upcomingActivity', state.upcomingActivity.concat(action.upcomingActivity))
			}else{
				return loadSuccessState.set('upcomingActivity', action.upcomingActivity)
			}

		case paymentActions.BUDGET_UPDATE_PAYMENT_AWARENESS:
			const updateActivity = (activity) => activity.map(a => a.id == action.id ? a.set('clientAwareness', LATE_PAYMENT_AWARENESS) : a)
			return state
				.update('upcomingActivity', updateActivity)
				.update('bPayActivity', updateActivity)
				.update('onHoldActivity', updateActivity)

		case actions.BUDGETING_UPDATE_UPCOMING_ACTIVITY_TAB:
			return state.set('upcomingActivityCurrentTab', action.tab)

		case actions.BUDGET_VERIFY_INCOME:
			return state
				.update('upcomingActivity', (activity) => activity.map(a => a.id == action.id ? a.set('clientAwareness', VERIFIED_INCOME) : a))
				.update('incomeActivity', (activity) => activity.map(a => a.id == action.id ? a.set('clientAwareness', VERIFIED_INCOME) : a))

		case actions.BUDGET_GET_UPCOMING_BPAY:
			return state.set('bPayActivity', action.payments)

		case actions.BUDGET_GET_UPCOMING_ON_HOLD:
			return state.set('onHoldActivity', action.payments)

		case paymentActions.BUDGET_REMOVE_PAYMENT:
			return state
				.update('bPayActivity', (bPayActivity) => bPayActivity.filter((item) => item.id != action.paymentId))
				.update('onHoldActivity', (onHoldActivity) => onHoldActivity.filter((item) => item.id != action.paymentId))

		case actions.BUDGET_GET_UPCOMING_INCOME:
			return state.set('incomeActivity', action.incomes)

		case actions.BUDGET_UPDATE_TWELVE_MONTH:
			return state.set('twelveMonth', action.twelveMonth)

	}

	return state
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/reducers/budgeting.js